import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard,
  Users,
  FileText,
  DollarSign,
  TrendingUp,
  TrendingDown,
  Settings,
  LogOut,
  ChevronLeft,
  Receipt,
  Building,
  Cloud,
  X,
  Instagram,
} from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ruonn-replica/artifacts/652j8z6m_logo%20letra%20transparente%20white.png';

const AdminSidebar = ({ isCollapsed, setIsCollapsed, isMobileOpen, setIsMobileOpen }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin');
  };

  const handleNavClick = () => {
    // Close mobile sidebar when a nav item is clicked
    if (setIsMobileOpen) setIsMobileOpen(false);
  };

  const navItems = [
    { path: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/leads', icon: Users, label: 'Leads' },
    { path: '/admin/clients', icon: Building, label: 'Clients' },
    { path: '/admin/invoices', icon: FileText, label: 'Invoices' },
    { path: '/admin/income', icon: TrendingUp, label: 'Income' },
    { path: '/admin/expenses', icon: TrendingDown, label: 'Expenses' },
    { path: '/admin/reports', icon: Receipt, label: 'Tax Reports' },
    { path: '/admin/cloud-service', icon: Cloud, label: 'Cloud Service' },
    { path: '/admin/ig-funnel', icon: Instagram, label: 'IG Funnel' },
    { path: '/admin/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <aside className={[
      'fixed left-0 top-0 h-full bg-[#1a1a1f] border-r border-white/5 transition-all duration-300 z-50 w-64',
      isMobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0',
      isCollapsed ? 'md:w-20' : 'md:w-64',
    ].join(' ')}>
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-white/5">
        <div className={`flex items-center gap-3 ${isCollapsed ? 'md:justify-center md:w-full' : ''}`}>
          <img src={LOGO_URL} alt="Ruonn" className="h-8 w-auto" />
          {!isCollapsed && <span className="text-white font-medium">Admin</span>}
        </div>
        {/* Desktop collapse button */}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="text-gray-400 hover:text-white transition-colors hidden md:block"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        {/* Mobile close button */}
        <button
          onClick={() => setIsMobileOpen(false)}
          className="text-gray-400 hover:text-white transition-colors md:hidden"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Navigation */}
      <nav className="p-4 space-y-2">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={handleNavClick}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                isActive
                  ? 'bg-purple-600 text-white'
                  : 'text-gray-400 hover:bg-white/5 hover:text-white'
              } ${isCollapsed ? 'md:justify-center' : ''}`
            }
          >
            <item.icon className="w-5 h-5 flex-shrink-0" />
            <span className={isCollapsed ? 'md:hidden' : ''}>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Bottom Section */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/5">
        <button
          onClick={handleLogout}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl text-gray-400 hover:bg-red-500/10 hover:text-red-400 transition-all w-full ${
            isCollapsed ? 'md:justify-center' : ''
          }`}
        >
          <LogOut className="w-5 h-5" />
          <span className={isCollapsed ? 'md:hidden' : ''}>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
